import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { NoResourceError } from '../../../shared/components/components/ui/error404';
import PriceApprovalContainer from './components/PriceApprovalContainer';


const ResourceAction = (props) => {
  const {
    resources,
    history,
    location,
    session,
  } = props;
  const [tag, setTag] = useState('');
  const brandName = session?.advertiser?.companyName || 'Brand';

  useEffect(() => {
    document.title = `${brandName} Brand Price Approval`;
  }, [brandName]);

  const resource = resources.find(r => r.id === 'CpmProspect');
  if (!resource) {
    return (<NoResourceError resourceId="CpmProspect" />);
  }
  const action = null;

  return (<PriceApprovalContainer
    filterVisible
    tag={tag}
    setTag={setTag}
    resource={resource}
    action={action}
    date={new Date()}
    history={history}
    location={location}
  />);
};
ResourceAction.propTypes = {
  resources: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  session: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = state => ({
  resources: state.resources,
  session: state.session,
});

export default connect(mapStateToProps)(ResourceAction);
